<header class="page-header">
	<h2>My Profile</h2>
</header>
<div class="w-full m-2 mt-10 flex">
	<!-- Left Column -->
	<div class="flex flex-col w-1/2 gap-4">
		<ui-section title="Closer profile">
			<form section-content (ngSubmit)="updateProfile(form)" #form="ngForm">
				<div class="flex gap-4">
					<app-input
						[required]="true"
						[submitted]="form.submitted"
						name="firstName"
						label="First name"
						[(ngModel)]="profile.firstName"
					></app-input>
					<app-input
						[required]="true"
						[submitted]="form.submitted"
						name="lastName"
						label="Last name"
						[(ngModel)]="profile.lastName"
					></app-input>
				</div>
				<div class="flex gap-4 mt-2">
					<app-input
						[required]="true"
						[submitted]="form.submitted"
						name="customInitails"
						label="Initials"
						labelToolTip="Max 4 characters"
						[(ngModel)]="profile.initials"
						[placeholder]="placeHolderInitials"
						[maxlength]="4"
					></app-input>
					<app-input
						[submitted]="form.submitted"
						name="faxNumber"
						label="Fax number"
						[(ngModel)]="profile.faxNumber"
					></app-input>
					<app-input
						[submitted]="form.submitted"
						name="phoneNumber"
						label="Phone number"
						[(ngModel)]="profile.phoneNumber"
					></app-input>
					<app-input
						class="w-1/3"
						[submitted]="form.submitted"
						name="extension"
						label="Ext."
						[(ngModel)]="profile.extension"
					></app-input>
				</div>
				<app-input
					class="mt-2"
					[required]="true"
					[submitted]="form.submitted"
					name="customSignature"
					label="Name in Signature line"
					[(ngModel)]="profile.customSignature"
					[placeholder]="placeHolderSignature"
				></app-input>
				<div class="flex justify-end mt-4">
					<app-button type="submit" btn="primary" [disabled]="!form.dirty"
						>Save</app-button
					>
				</div>
			</form>
		</ui-section>

		<ui-section title="Change Email" *ngIf="showChangeEmail">
			<form
				section-content
				(ngSubmit)="updateEmail(emailForm)"
				class="flex flex-col"
				#emailForm="ngForm"
			>
				<div class="flex flex-col mt-4">
					<app-input
						class="mx-2"
						type="email"
						[required]="true"
						[submitted]="emailForm.submitted"
						name="email"
						label="New email"
						[(ngModel)]="profile.email"
					></app-input>
					<app-input
						class="mx-2 mt-4"
						type="password"
						[required]="true"
						[submitted]="emailForm.submitted"
						name="password"
						label="Password"
						[(ngModel)]="password"
					></app-input>
					<label class="mx-2 mt-2 text-grey-light"
						>You need to provide your current password in order to change your
						email</label
					>
				</div>
				<div class="flex justify-end mt-4">
					<app-button type="submit" btn="primary" [disabled]="!emailForm.dirty"
						>Save</app-button
					>
				</div>
			</form>
		</ui-section>

		<ui-section title="Change Password" *ngIf="showChangeEmail">
			<form
				section-content
				(ngSubmit)="changePassword(emailForm)"
				class="flex flex-col"
				#emailForm="ngForm"
			>
				<div class="flex flex-col mt-4">
					<app-input
						label="Current password"
						class="mx-2 mt-4"
						type="password"
						[(ngModel)]="oldPassword"
						name="currentPassword"
						[required]="true"
						[submitted]="emailForm.submitted"
					></app-input>
					<app-input
						label="New password"
						class="mx-2 mt-4"
						type="password"
						[(ngModel)]="newPassword"
						name="newPassword"
						[required]="true"
						[submitted]="emailForm.submitted"
						minLength="6"
						minLengthLabel="Password"
					></app-input>
					<app-input
						label="Confirm new password"
						class="mx-2 mt-4"
						type="password"
						[(ngModel)]="newPasswordConfirmation"
						name="newPasswordConfirmation"
						[passwordsMatch]="newPassword"
						[required]="true"
						[submitted]="emailForm.submitted"
					></app-input>
				</div>
				<div class="flex justify-end mt-4">
					<app-button
						type="submit"
						class="mt-4"
						btn="primary"
						[disabled]="!emailForm.dirty"
						>Change password</app-button
					>
				</div>
			</form>
		</ui-section>

		<ui-section
			title="Email Integration with Closer"
			*ngIf="outlookIntegrationEnabled$ | async"
		>
			<ui-button actions label="Connect" (click)="connectEmail()"></ui-button>
			<div section-content class="flex flex-col gap-8">
				<div class="flex gap-8">
					<!-- <img
						src="assets/images/emails/logos/gmail-logo.png"
						alt="Gmail Logo"
						class="max-h-10 w-auto"
					/> -->
					<img
						src="assets/images/emails/logos/outlook-logo.png"
						alt="Outlook Logo"
						class="max-h-10 w-auto"
					/>
				</div>
				<p class="p">
					Connect your email to send client intake forms and set up templates —
					right from Closer. More email features coming soon
				</p>
			</div>
		</ui-section>
	</div>

	<!--	Right Column -->
	<div class="m-2 flex flex-col w-1/2">
		<app-container class="m-2 p-2 flex justify-center w-full flex-none">
			<div class="flex justify-between items-center">
				<h3>Manage Your Accounts</h3>
				<app-button
					*ngIf="profile.multiBusiness"
					btn="primary"
					size="small"
					[icon]="ICON.ADD"
					(onClick)="createNewBusiness()"
					data-intercom-target="create-account"
				>
					Create Account
				</app-button>
			</div>

			<div class="m-2 flex flex-col w-full">
				<div
					*ngFor="
						let account of businessAccounts$ | async;
						trackBy: trackByBusinessId
					"
					class="flex justify-between items-center m-3"
				>
					<div class="flex gap-2 items-center">
						<p>{{ account.name }}</p>
					</div>
					<div
						*ngIf="account.isActive"
						class="flex items-center ng-star-inserted"
					>
						<div class="w-2 h-2 bg-green rounded-full mr-2"></div>
						<span class="text-gray"> Logged In </span>
					</div>
					<ui-button
						*ngIf="!account.isActive"
						label="Go To Account"
						data-intercom-target="???"
						size="sm"
						preset="EXTRA_LOW_EMPHASIS"
						(click)="goToAccount(account.businessId)"
					></ui-button>
				</div>
			</div>

			<div class="m-2 flex flex-col w-full">
				<div
					*ngFor="
						let invite of businessInvites$ | async;
						trackBy: trackByInviteId
					"
					class="flex justify-between items-center m-3"
				>
					<div class="flex gap-2 items-center">
						<p>{{ invite.businessName }}</p>
						<ui-pill></ui-pill>
					</div>
					<ui-button
						label="View Invite"
						data-intercom-target="???"
						size="sm"
						preset="EXTRA_LOW_EMPHASIS"
						(click)="openInviteModal(invite)"
					></ui-button>
				</div>
			</div>

			<!--			<div-->
			<!--				*ngIf="!profile.multiBusiness"-->
			<!--				class="w-full gap-2 rounded-lg border border-green-lighter bg-green-lightest p-5 flex flex-col justify-center m-2"-->
			<!--			>-->
			<!--				<div class="flex items-center gap-2">-->
			<!--					<app-icon [icon]="ICON.INFO" class="text-gray"></app-icon>-->
			<!--					<p class="text-base text-grey-darkest">-->
			<!--						Enable multiple business accounts-->
			<!--					</p>-->
			<!--				</div>-->
			<!--				<div class="flex flex-col gap-4 m-2">-->
			<!--					<p class="text-sm text-grey">-->
			<!--						Are you interested in adding multiple business to one account?-->
			<!--						Contact our team to get started with our BETA.-->
			<!--					</p>-->
			<!--					<ui-anchor (click)=""> Contact Us NOT DONE!! </ui-anchor>-->
			<!--				</div>-->
			<!--			</div>-->
		</app-container>
	</div>
</div>
